import { render, staticRenderFns } from "./PublishTask.vue?vue&type=template&id=87ccc3c0&scoped=true&"
import script from "./PublishTask.vue?vue&type=script&lang=js&"
export * from "./PublishTask.vue?vue&type=script&lang=js&"
import style0 from "./PublishTask.vue?vue&type=style&index=0&id=87ccc3c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ccc3c0",
  null
  
)

export default component.exports